import { render } from "./ReportInsightComponent.vue?vue&type=template&id=2f4c7976&scoped=true"
import script from "./ReportInsightComponent.vue?vue&type=script&lang=js"
export * from "./ReportInsightComponent.vue?vue&type=script&lang=js"

import "./ReportInsightComponent.vue?vue&type=style&index=0&id=2f4c7976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4c7976"]])

export default __exports__